<template>
    <div>
        <div class="card ">
            <div class="card-header main-card">
                Administración de hoteles y pickups
            </div>
            <div class="d-flex justify-content-between my-4 mx-4">
                <div>
                    <ul>
                        <li class="ml-3 text-danger font-weight-bold" v-if="geopointsWithoutZoneAdmin.length > 0">
                            <i class="fa fa-2x fa-fw fa-exclamation-triangle" />
                            {{geopointsWithoutZoneAdmin.length}} puntos (HOTELES) NO tienen asignado resort
                        </li>
                        <li class="ml-3 text-danger font-weight-bold" v-else>
                            <i class="fa fa-2x fa-fw fa-check-circle" />
                            Todos los puntos (HOTELES) tienen asignado resort
                        </li>
                    </ul>
                    <ul v-if="suprazone_id && suprazone_id > 0 ">
                        <li class="ml-3 text-danger font-weight-bold" v-if="withoutMap.length > 0">
                            <i class="fa fa-2x fa-fw fa-exclamation-triangle" />
                            {{withoutMap.length}}/{{pickups.length}} paradas no tienen mapa
                        </li>
                        <li class="ml-3 text-danger font-weight-bold" v-else>
                            <i class="fa fa-2x fa-fw fa-check-circle" />
                            Todas las paradas tiene asignado mapa
                        </li>
                    </ul>
                </div>
                <div>
                    <b-button @click="syncPoints()" class="border text-right" variant="light">
                        <i v-if="!loadingSync" class="fa fa-cloud-download mr-2" aria-hidden="true"></i>
                        <i v-else class="fa fa-spinner fa-spin mr-2"></i>
                        <span>Sincronizar con ZT</span>
                    </b-button>
                    <p v-if="loadingSync" class="text-right">Sincronización en curso, espere unos instantes...</p>
                </div>
            </div>
            
            <div class="card-body">
                <div>
                    <div class="mb-4 d-flex">
                        <div class="flex mr-3">
                            <span class="mr-4" style="display:block">
                            Selecciona la zona
                            </span>
                            <b-form-select @change="getData" v-model="suprazone_id" class="">
                                <option value="0">Seleccione zona...</option>
                                <option v-for="suprazone in suprazones" :key="suprazone.id" :value="suprazone.id">{{suprazone.name}}</option>
                            </b-form-select>
                        </div>
                        <div class="flex mx-3" v-if="suprazone_id != 0">
                            <span class="" style="display:block">
                                Filtrar por nombe
                            </span>
                            <b-form-input
                                v-model="filtering.filter_name"
                                
                                class="border" style="display:block; border-color: #999 !important;"
                            >

                            </b-form-input>
                        </div>
                        <div class="flex mx-3" v-if="suprazone_id != 0">
                            <span class="" style="display:block" >
                                Filtrar por resort
                            </span>
                            <b-form-select v-model="filtering.resort" class="">
                                <option value="0">Ver todos los resorts</option>
                                <optgroup v-for="(grp, idx) in grouping" :key="idx" :label="idx">
                                    <option v-for="item in grp" :key="item.id" :value="item.id">{{item.name}}</option>
                                </optgroup>
                            </b-form-select>
                            
                        </div>
                        <div class="flex mx-3" v-if="suprazone_id != 0">
                            <span class="" style="display:block" >
                                Ordenar
                            </span>
                            <b-form-select v-model="filtering.orderPoints" class="">
                                <!-- <option value="0">Seleccione orden...</option> -->
                                <option value="by_geo_name">Ordenar por hotel (alfabético ASC)</option>
                                <option value="by_zone_name">Ordenar por resort (alfabético ASC)</option>
                            </b-form-select>
                            
                        </div>
                        <div class="flex mx-3" v-if="suprazone_id != 0">
                            <b-form-group label="Ver" class="d-flex">
                                <b-form-radio-group v-model="filtering.filterPoints" id="radio-group-ver">
                                    <b-form-radio name="ver-todo" :value="'todo'">Todo</b-form-radio>
                                    <b-form-radio name="ver-paradas" :value="'paradas'">Solo paradas</b-form-radio>
                                    <b-form-radio name="ver-hoteles" :value="'hoteles'">Solo hoteles</b-form-radio>
                                    <b-form-radio name="ver-hoteles" :value="'paradas-no-hotel'">Solo paradas no hotel</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </div>

                        
                    </div>
                    
                    <div v-if="suprazone_id != 0">
                        <p  class="text-center font-weight-bold">
                            Listado de puntos geográficos de la {{suprazone != undefined ? suprazone.name : ''}} (hoteles, paradas)
                        </p>
                        <div class="d-flex justify-content-between">
                            <div>
                                <ul>
                                    <li>{{geopointsListAdmin.length}} puntos geográficos en total, de los cuales {{hotels.length}} son hoteles y {{pickups.length}} puntos de recogida (tener en cuenta que algunos puntos son hotel y recogida al mismo tiempo)</li>
                                </ul>
                            </div>
                            <div>
                                <b-dropdown
                                    size="lg"
                                    variant="link"
                                    toggle-class="text-decoration-none"
                                    class="float-right"
                                    no-caret
                                    right
                                    v-if="suprazone_id > 0"
                                >
                                    <template v-slot:button-content>
                                        <i class="fa fa-ellipsis-v"></i>
                                    </template>
                                    <b-dropdown-item>
                                        <div v-b-modal="'addGeoPoint'">
                                            <i class="fa fa-plus-circle mr-2 fa-fw"/> Nuevo
                                        </div>
                                        <admin-add-geo-point-modal 
                                            :suprazone="suprazone"
                                        />
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                    </div>
                    
                    <table class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">Nombre remoto</th>
                                <th scope="col">Hotel</th>
                                <th scope="col">Recogida</th>
                                <!-- <th scope="col">Punto recogida</th> -->
                                <th scope="col">Punto encuentro</th>
                                <th scope="col">Resort</th>
                                <th scope="col">Mapa</th>
                                <th scope="col">QR</th>
                                <th scope="col">ZT id</th>
                                <th scope="col">Sync ZT</th>
                                <th scope="col">Configurar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <admin-geopoints-table-row 
                                :item="point" 
                                v-for="point in points" 
                                :key="point.id" 
                                :selectedSuprazone="suprazone_id"
                            />
                        </tbody>
                    </table>

                    <p class="text-center font-weight-bold" style="margin-top: 5rem; border-top: 1px solid; padding-top: 2rem;">Puntos geográficos sin resort asignado</p>
                    
                    <div class="mb-4 d-flex">
                        <div>
                            <span class="mx-4">
                                Filtrar por nombe
                            </span>

                            <b-form-input
                                v-model="filter_name_unassigned"
                                @keyup="onFilterGeopointNameUnassigned"
                                class="border"
                            >

                            </b-form-input>
                        </div>
                    </div>
                    <table class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">Nombre remoto</th>
                                <th scope="col">Hotel</th>
                                <th scope="col">Recogida</th>
                                <!-- <th scope="col">Punto recogida</th> -->
                                <th scope="col">Resort</th>
                                <th scope="col">Mapa</th>
                                <th scope="col">QR</th>
                                <th scope="col">ZT id</th>
                                <th scope="col">Sync ZT</th>
                                <th scope="col">Configurar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <admin-geopoints-table-row 
                                :item="point" 
                                v-for="point in unassignedPoints" 
                                :key="point.id" 
                                :selectedSuprazone="suprazone_id"
                            />
                        </tbody>
                    </table>                
                </div>
                <admin-hotel-stop-groups-edit-modal :suprazone="suprazone" />
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import AdminGeopointsTableRow from './AdminGeopointsTableRow';
import AdminAddGeoPointModal from './AdminAddGeoPointModal';
import AdminHotelStopGroupsEditModal from '../HotelStopGroups/AdminHotelStopGroupsEditModal';


import { mapGetters } from 'vuex';

export default {
    components: {
        AdminGeopointsTableRow,
        AdminAddGeoPointModal,
        AdminHotelStopGroupsEditModal,
    },
    data() {
        return {
            suprazone_id: 0,
            suprazone: {},
            filter_name: '',
            filter_name_unassigned: '',
            points: this.geopointsListAdmin,
            unassignedPoints: this.geopointsWithoutZoneAdmin,
            loadingSync: false,
            filterPoints: 'todo',
            orderPoints: 'by_zone_name',
            filtering: {
                filter_name: '',
                filterPoints: 'todo',
                orderPoints: 'by_geo_name',
                resort: 0
            }
        }
    },
    async mounted() {
        await this.$store.dispatch("suprazones/loadSuprazones")
        await this.$store.dispatch("geopoints/getAllGeopointsWithoutAssignedZone")
        
    },
    methods: {
        async getData() {
            // load all suprazones
            await this.$store.dispatch("suprazones/loadSuprazones")
            //this.points = this.geopointsListAdmin
            
            await this.$store.dispatch('subzones/getSubzonesBySuprazone', {suprazone_id: this.suprazone_id})
            this.suprazone = this.suprazoneAdminCurrent(this.suprazone_id)

            const data = {
                'suprazone_id': this.suprazone_id,
            }
            await this.$store.dispatch("geopoints/getAllGeopointsBySuprazone", data)
            await this.$store.dispatch("geopoints/getAllGeopointsWithoutAssignedZone")
            this.points = this.geopointsListAdmin
            this.order()
        },
        onFilterGeopointName() {
            if ( this.filtering.filter_name.length > 1) {
                this.points = this.points.filter( 
                    item => item.name.toLowerCase().includes(this.filtering.filter_name)
                )
            }
            // } else if ( this.filtering.filter_name.length <= 1 ) {
            //     this.points = this.geopointsListAdmin
            // }
        },
        onFilterGeopointNameUnassigned() {
            if ( this.filter_name_unassigned.length > 1 ) {
                this.unassignedPoints = this.geopointsWithoutZoneAdmin.filter(
                    item => item.name.toLowerCase().includes(this.filter_name_unassigned)
                )
            } else if (this.filter_name_unassigned.length <= 1 ) {
                this.unassignedPoints = this.geopointsWithoutZoneAdmin
            }
        },
        newGeoPoint() {
            alert('no implementado aún')
        },
        async syncPoints() {
            this.loadingSync = true
            this.suprazone_id = 0
            await this.$store.dispatch("geopoints/syncHotels")
            this.$notify({
                group: "foo",
                title: "Hoteles sincronizados",
                text: "Se han sincronizado los hoteles desde el sistema de reservas ZT",
                type: "success"
            });
            this.loadingSync = false
        },
        filter() {
            if ( this.filtering.filterPoints == 'todo' ) {
                //this.points = this.points
            }
            else if ( this.filtering.filterPoints == 'hoteles' ) {
                this.points = this.points.filter((item) => item.is_hotel)
            }
            else if ( this.filtering.filterPoints == 'paradas') {
                this.points = this.points.filter((item) => item.is_pickup)
            }
            else if ( this.filtering.filterPoints == 'paradas-no-hotel') {
                this.points = this.points.filter((item) => item.is_pickup && !item.is_hotel)
            }
        },
        order() {
            if ( this.filtering.orderPoints == 'by_zone_name') {

                function sortPoints(points) {
                    const order = ({ sub_zone }) => sub_zone.name;
                    points.sort((a, b) => {
                        if ( order(a) < order(b) ) return -1
                        if ( order(a) > order(b) ) return 1
                        return 0
                    } );

                    return points;
                }
                this.points = sortPoints(this.points)
            }
            else if ( this.filtering.orderPoints == 'by_geo_name' ) {
                this.points = this.points.sort((a, b) => {
                    const geoNameA = a.name.toUpperCase()
                    const geoNameB = b.name.toUpperCase()
                    if ( geoNameA < geoNameB ) {
                        return -1
                    }
                    if ( geoNameA > geoNameB ) {
                        return 1
                    }
                    return 0
                })
            }
        },
        filterResort() {
            if ( this.filtering.resort > 0 ) {
                this.points = this.points.filter((item) => {
                    if ( item.sub_zone != null )
                        return item.sub_zone.id == this.filtering.resort
                    return false
                })
            }
        },
        triggerFiltering() {
            this.points = this.geopointsListAdmin
            this.filter()
            this.onFilterGeopointName()
            this.filterResort()
            this.order()
        }
    },
    beforeDestroy() {
        // clean list
        this.$store.commit('geopoints/RESET_GEOPOINTS_LIST_ADMIN')
    },
    computed: {
        ...mapGetters(['geopointsListAdmin', 'toggleGeopointLitAdmin', 'suprazones', 'suprazoneAdminCurrent', 'activeOption', 'activeTab', 'isDataLoading', 'geopointsWithoutZoneAdmin', 'subzonesListAdmin']),
        hotels() {
            return this.geopointsListAdmin.filter(
                item => item.is_hotel == true
            )
        },
        hotelsWithoutStop() {
            return this.geopointsListAdmin.filter(
                item => item.pickup_point == null
            )
        },
        pickups() {
            return this.geopointsListAdmin.filter(
                item => item.is_pickup == true
            )
        },
        grouping() {
            let g = _.mapValues(
                _.groupBy(
                    this.subzonesListAdmin, 'pickup_zone.name'
                ),
            )
            return g
        },
        withoutMap() {
            return this.geopointsListAdmin.filter(
                item => item.is_pickup == true && item.map == ''
            )
        }
    },
    watch: {
        // geopointsListAdmin: function() {
        //     console.log('chaged geopointsListAdmin')
        //     this.points = this.geopointsListAdmin
        //     //this.onFilterGeopointName()
        //     this.filter()
        //     this.onFilterGeopointName()
        //     this.filterResort()
        //     this.order()
        //     //this.getData()
            
        // },
        geopointsWithoutZoneAdmin: function() {
            this.onFilterGeopointNameUnassigned()
        },
        filtering: {
            handler: function() {
                this.triggerFiltering()
            },
            deep:true
        },
        toggleGeopointLitAdmin: {
            handler: function() {
                this.triggerFiltering()
            },
            deep: true
        }
    }
}
</script>


